import { render, staticRenderFns } from "./DifDirectorio.vue?vue&type=template&id=5f0a1fb8&"
import script from "./DifDirectorio.vue?vue&type=script&lang=js&"
export * from "./DifDirectorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports